import {
    NineSlicePlane
} from 'pixi.js';
import { LoadContext } from '../utils';

const FRAME_WIDTH = 6;

export class FocusFrame extends NineSlicePlane
{
    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('SharedUI', './assets/shared/SharedUI{size}.json');
    }

    constructor(width: number, height: number)
    {
        const loader = LoadContext.current;
        super(loader.getTexture('highlight_frame', 'SharedUI'), FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH);
        this.width = width;
        this.height = height;
    }
}